module.exports = __webpack_public_path__ + "img/00049.75315bb9.webp";